module.exports = __webpack_public_path__ + "img/js-3.67d7fa5f.jpg";